import React from "react";
import '../auth.css';
import '../card.css';
import axios from 'axios';
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBCardBody } from 'mdbreact';
import i18n from '../i18n';
import {connect} from 'react-redux';
import Menutest from './menu.js';
import {reactLocalStorage} from 'reactjs-localstorage';
import { SemanticToastContainer, toast } from 'react-semantic-toasts';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
import { API_BASE_URL } from "../utils/endpoints";

class AddCategory extends React.Component {


    state = {
        categoryName: '',
  
     }
  
     handleChange = event => {
       this.setState({ categoryName: event.target.value});
 
     }
 
     handleChange = event => {
      this.setState({ categoryName: event.target.value});

    }

    handleSubmit = event => {
       event.preventDefault();
 
       
       var token=reactLocalStorage.get('accessToken');
       var data={
         user_id:reactLocalStorage.get('user_id_login'),
         category_name:this.state.categoryName
       };
      var ip=API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if(ip.includes(s2))
      {
        apiBaseUrl = API_BASE_URL + "/core/user/rest/contacts/createCategory";
      }
      else
      {
       apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/createCategory";
      }
       var headers = {
        'Content-Type': 'application/json',
        'token':token
         }
       axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
       {
 
       if(response.status === 200)
       {
         if(response.data.status === 'failed')
         {

           toast({
             type: 'warning',
             title:i18n.t('warning.label'),
             description:response.data.result.ErrorDescription,
             animation: 'bounce',
             time: 5000,
            
         });
         }
         else{
            window.location="Group";
         }
         
 
 
       }
       else if(response.status === 204){
       console.log("Something wrong");
       toast({
         type: 'error',
         title: i18n.t('error.label'),
         description:i18n.t('Something_wrong.label'),
         animation: 'bounce',
         time: 5000,

     });
 
       }
       else{
       console.log("Something wrong");
       toast({
         type: 'error',
         title: i18n.t('error.label'),
         description:i18n.t('Something_wrong.label'),
         animation: 'bounce',
         time: 5000,

     });
 
       }
       })
       .catch(function (error) {
       console.log(error);
       toast({
         type: 'error',
         title: i18n.t('error.label'),
         description:i18n.t('Something_wrong.label'),
         animation: 'bounce',
         time: 5000,

     });
       });
     }
      back=()=>
      {
        window.location="group";
      }
      componentDidMount(){
  
        var lang=i18n.language;
        if(lang ==="ar")
        {
          document.querySelector('.title_cat').style = 'text-align:right;';       
        
        }

 }
render(){
    return(
      <div className="big_div">
      <Menutest/>
      <div className="actionMenu">
        <div>
                          <div className="add_form" style={{ paddingBottom: '2%'}}> 
                    <MDBContainer>
                    <MDBRow>
                        <MDBCol md="6">
                        <MDBCard className="add_card">
                            <MDBCardBody>
                            <form onSubmit={this.handleSubmit} className="title_cat">
                                <p className="h4 text-center py-4 text_style ">{i18n.t('Add_Category.label')}</p>
                                <label
                                htmlFor="defaultFormCardNameEx"
                                className="grey-text font-weight-light"
                                >
                                
                                {i18n.t('Name_of_Category.label')}

                                </label>
                                <input
                                type="text"
                                id="defaultFormCardNameEx"
                                className="form-control"
                                required="required"
                                name="title"
                                onChange={this.handleChange}
                                />
                                <br />
                            
                                <div className="text-center py-4 mt-3">
                            
   
                                <button className="submit_btn_pink">

                                  <MDBBtn color="cyan"  onClick={this.back}>
                                  {i18n.t('Back.label')}
                                  </MDBBtn>
                                  </button>
                                <button className="submit_btn_pink">
                                    <MDBBtn color="cyan" type="submit">
                                    {i18n.t('Submit.label')}
                                    </MDBBtn>
                                    </button>

                                </div>
                            </form>
                            </MDBCardBody>
                        </MDBCard>
                        </MDBCol>
                    </MDBRow>
                    </MDBContainer>
                    <SemanticToastContainer/>
                    </div>
        </div> </div> </div>
    );
}

}


const mapStateToProps = (state)=>{
  return {...state}
}
export default connect(mapStateToProps) (AddCategory);
